/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ItemBannerDto } from '../model/itemBannerDto';
import { ItemForAppStoreDto } from '../model/itemForAppStoreDto';
import { ItemGetOneDto } from '../model/itemGetOneDto';
import { ItemOutputDto } from '../model/itemOutputDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ItemService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemBannerItemsByStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ItemBannerDto>>;
    public apiItemBannerItemsByStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ItemBannerDto>>>;
    public apiItemBannerItemsByStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ItemBannerDto>>>;
    public apiItemBannerItemsByStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ItemBannerDto>>('get',`${this.basePath}/api/Item/BannerItemsByStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdItem 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemDeleteDelete(cdItem?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiItemDeleteDelete(cdItem?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiItemDeleteDelete(cdItem?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiItemDeleteDelete(cdItem?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdItem !== undefined && cdItem !== null) {
            queryParameters = queryParameters.set('cdItem', <any>cdItem);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('delete',`${this.basePath}/api/Item/Delete`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdItem 
     * @param state 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemEnableOrDisableItemBannerPut(cdItem?: number, state?: boolean, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiItemEnableOrDisableItemBannerPut(cdItem?: number, state?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiItemEnableOrDisableItemBannerPut(cdItem?: number, state?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiItemEnableOrDisableItemBannerPut(cdItem?: number, state?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdItem !== undefined && cdItem !== null) {
            queryParameters = queryParameters.set('cdItem', <any>cdItem);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/Item/EnableOrDisableItemBanner`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param cdItemsCategory 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemGetAllByCategoryGet(cdStore?: number, cdItemsCategory?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ItemForAppStoreDto>>;
    public apiItemGetAllByCategoryGet(cdStore?: number, cdItemsCategory?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ItemForAppStoreDto>>>;
    public apiItemGetAllByCategoryGet(cdStore?: number, cdItemsCategory?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ItemForAppStoreDto>>>;
    public apiItemGetAllByCategoryGet(cdStore?: number, cdItemsCategory?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }
        if (cdItemsCategory !== undefined && cdItemsCategory !== null) {
            queryParameters = queryParameters.set('cdItemsCategory', <any>cdItemsCategory);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ItemForAppStoreDto>>('get',`${this.basePath}/api/Item/GetAllByCategory`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemGetAllForAppStoreGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ItemForAppStoreDto>>;
    public apiItemGetAllForAppStoreGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ItemForAppStoreDto>>>;
    public apiItemGetAllForAppStoreGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ItemForAppStoreDto>>>;
    public apiItemGetAllForAppStoreGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ItemForAppStoreDto>>('get',`${this.basePath}/api/Item/GetAllForAppStore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemGetAllGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ItemOutputDto>>;
    public apiItemGetAllGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ItemOutputDto>>>;
    public apiItemGetAllGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ItemOutputDto>>>;
    public apiItemGetAllGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdStore !== undefined && cdStore !== null) {
            queryParameters = queryParameters.set('cdStore', <any>cdStore);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ItemOutputDto>>('get',`${this.basePath}/api/Item/GetAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdItem 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemGetCdItemGet(cdItem: number, observe?: 'body', reportProgress?: boolean): Observable<ItemGetOneDto>;
    public apiItemGetCdItemGet(cdItem: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ItemGetOneDto>>;
    public apiItemGetCdItemGet(cdItem: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ItemGetOneDto>>;
    public apiItemGetCdItemGet(cdItem: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cdItem === null || cdItem === undefined) {
            throw new Error('Required parameter cdItem was null or undefined when calling apiItemGetCdItemGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ItemGetOneDto>('get',`${this.basePath}/api/Item/Get/${encodeURIComponent(String(cdItem))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdItem 
     * @param state 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemItemStatePut(cdItem?: number, state?: boolean, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiItemItemStatePut(cdItem?: number, state?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiItemItemStatePut(cdItem?: number, state?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiItemItemStatePut(cdItem?: number, state?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdItem !== undefined && cdItem !== null) {
            queryParameters = queryParameters.set('cdItem', <any>cdItem);
        }
        if (state !== undefined && state !== null) {
            queryParameters = queryParameters.set('state', <any>state);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/Item/ItemState`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdStore 
     * @param cdItemsCategory 
     * @param dsName 
     * @param dsDescription 
     * @param dsImg 
     * @param itemImage 
     * @param qtSmallPrice 
     * @param qtMediumPrice 
     * @param qtLargePrice 
     * @param nmSortNo 
     * @param isNonveg 
     * @param dsSmallText 
     * @param dsMediumText 
     * @param dsLargeText 
     * @param dsImageCode 
     * @param isActive 
     * @param isBanner 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemPostPostForm(cdStore?: number, cdItemsCategory?: number, dsName?: string, dsDescription?: string, dsImg?: string, itemImage?: Blob, qtSmallPrice?: number, qtMediumPrice?: number, qtLargePrice?: number, nmSortNo?: number, isNonveg?: boolean, dsSmallText?: string, dsMediumText?: string, dsLargeText?: string, dsImageCode?: string, isActive?: boolean, isBanner?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiItemPostPostForm(cdStore?: number, cdItemsCategory?: number, dsName?: string, dsDescription?: string, dsImg?: string, itemImage?: Blob, qtSmallPrice?: number, qtMediumPrice?: number, qtLargePrice?: number, nmSortNo?: number, isNonveg?: boolean, dsSmallText?: string, dsMediumText?: string, dsLargeText?: string, dsImageCode?: string, isActive?: boolean, isBanner?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiItemPostPostForm(cdStore?: number, cdItemsCategory?: number, dsName?: string, dsDescription?: string, dsImg?: string, itemImage?: Blob, qtSmallPrice?: number, qtMediumPrice?: number, qtLargePrice?: number, nmSortNo?: number, isNonveg?: boolean, dsSmallText?: string, dsMediumText?: string, dsLargeText?: string, dsImageCode?: string, isActive?: boolean, isBanner?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiItemPostPostForm(cdStore?: number, cdItemsCategory?: number, dsName?: string, dsDescription?: string, dsImg?: string, itemImage?: Blob, qtSmallPrice?: number, qtMediumPrice?: number, qtLargePrice?: number, nmSortNo?: number, isNonveg?: boolean, dsSmallText?: string, dsMediumText?: string, dsLargeText?: string, dsImageCode?: string, isActive?: boolean, isBanner?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


















        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cdStore !== undefined) {
            formParams = formParams.append('CdStore', <any>cdStore) as any || formParams;
        }
        if (cdItemsCategory !== undefined) {
            formParams = formParams.append('CdItemsCategory', <any>cdItemsCategory) as any || formParams;
        }
        if (dsName !== undefined) {
            formParams = formParams.append('DsName', <any>dsName) as any || formParams;
        }
        if (dsDescription !== undefined) {
            formParams = formParams.append('DsDescription', <any>dsDescription) as any || formParams;
        }
        if (dsImg !== undefined) {
            formParams = formParams.append('DsImg', <any>dsImg) as any || formParams;
        }
        if (itemImage !== undefined) {
            formParams = formParams.append('ItemImage', <any>itemImage) as any || formParams;
        }
        if (qtSmallPrice !== undefined) {
            formParams = formParams.append('QtSmallPrice', <any>qtSmallPrice) as any || formParams;
        }
        if (qtMediumPrice !== undefined) {
            formParams = formParams.append('QtMediumPrice', <any>qtMediumPrice) as any || formParams;
        }
        if (qtLargePrice !== undefined) {
            formParams = formParams.append('QtLargePrice', <any>qtLargePrice) as any || formParams;
        }
        if (nmSortNo !== undefined) {
            formParams = formParams.append('NmSortNo', <any>nmSortNo) as any || formParams;
        }
        if (isNonveg !== undefined) {
            formParams = formParams.append('IsNonveg', <any>isNonveg) as any || formParams;
        }
        if (dsSmallText !== undefined) {
            formParams = formParams.append('DsSmallText', <any>dsSmallText) as any || formParams;
        }
        if (dsMediumText !== undefined) {
            formParams = formParams.append('DsMediumText', <any>dsMediumText) as any || formParams;
        }
        if (dsLargeText !== undefined) {
            formParams = formParams.append('DsLargeText', <any>dsLargeText) as any || formParams;
        }
        if (dsImageCode !== undefined) {
            formParams = formParams.append('DsImageCode', <any>dsImageCode) as any || formParams;
        }
        if (isActive !== undefined) {
            formParams = formParams.append('IsActive', <any>isActive) as any || formParams;
        }
        if (isBanner !== undefined) {
            formParams = formParams.append('IsBanner', <any>isBanner) as any || formParams;
        }

        return this.httpClient.request<number>('post',`${this.basePath}/api/Item/Post`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdItem 
     * @param cdStore 
     * @param cdItemsCategory 
     * @param dsName 
     * @param dsDescription 
     * @param dsNewImg 
     * @param qtSmallPrice 
     * @param qtMediumPrice 
     * @param qtLargePrice 
     * @param nmSortNo 
     * @param isNonveg 
     * @param dsSmallText 
     * @param dsMediumText 
     * @param dsLargeText 
     * @param dsImageCode 
     * @param isActive 
     * @param itemImage 
     * @param isBanner 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemPutPutForm(cdItem?: number, cdStore?: number, cdItemsCategory?: number, dsName?: string, dsDescription?: string, dsNewImg?: string, qtSmallPrice?: number, qtMediumPrice?: number, qtLargePrice?: number, nmSortNo?: number, isNonveg?: boolean, dsSmallText?: string, dsMediumText?: string, dsLargeText?: string, dsImageCode?: string, isActive?: boolean, itemImage?: Blob, isBanner?: boolean, observe?: 'body', reportProgress?: boolean): Observable<ItemOutputDto>;
    public apiItemPutPutForm(cdItem?: number, cdStore?: number, cdItemsCategory?: number, dsName?: string, dsDescription?: string, dsNewImg?: string, qtSmallPrice?: number, qtMediumPrice?: number, qtLargePrice?: number, nmSortNo?: number, isNonveg?: boolean, dsSmallText?: string, dsMediumText?: string, dsLargeText?: string, dsImageCode?: string, isActive?: boolean, itemImage?: Blob, isBanner?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ItemOutputDto>>;
    public apiItemPutPutForm(cdItem?: number, cdStore?: number, cdItemsCategory?: number, dsName?: string, dsDescription?: string, dsNewImg?: string, qtSmallPrice?: number, qtMediumPrice?: number, qtLargePrice?: number, nmSortNo?: number, isNonveg?: boolean, dsSmallText?: string, dsMediumText?: string, dsLargeText?: string, dsImageCode?: string, isActive?: boolean, itemImage?: Blob, isBanner?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ItemOutputDto>>;
    public apiItemPutPutForm(cdItem?: number, cdStore?: number, cdItemsCategory?: number, dsName?: string, dsDescription?: string, dsNewImg?: string, qtSmallPrice?: number, qtMediumPrice?: number, qtLargePrice?: number, nmSortNo?: number, isNonveg?: boolean, dsSmallText?: string, dsMediumText?: string, dsLargeText?: string, dsImageCode?: string, isActive?: boolean, itemImage?: Blob, isBanner?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



















        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (cdItem !== undefined) {
            formParams = formParams.append('CdItem', <any>cdItem) as any || formParams;
        }
        if (cdStore !== undefined) {
            formParams = formParams.append('CdStore', <any>cdStore) as any || formParams;
        }
        if (cdItemsCategory !== undefined) {
            formParams = formParams.append('CdItemsCategory', <any>cdItemsCategory) as any || formParams;
        }
        if (dsName !== undefined) {
            formParams = formParams.append('DsName', <any>dsName) as any || formParams;
        }
        if (dsDescription !== undefined) {
            formParams = formParams.append('DsDescription', <any>dsDescription) as any || formParams;
        }
        if (dsNewImg !== undefined) {
            formParams = formParams.append('DsNewImg', <any>dsNewImg) as any || formParams;
        }
        if (qtSmallPrice !== undefined) {
            formParams = formParams.append('QtSmallPrice', <any>qtSmallPrice) as any || formParams;
        }
        if (qtMediumPrice !== undefined) {
            formParams = formParams.append('QtMediumPrice', <any>qtMediumPrice) as any || formParams;
        }
        if (qtLargePrice !== undefined) {
            formParams = formParams.append('QtLargePrice', <any>qtLargePrice) as any || formParams;
        }
        if (nmSortNo !== undefined) {
            formParams = formParams.append('NmSortNo', <any>nmSortNo) as any || formParams;
        }
        if (isNonveg !== undefined) {
            formParams = formParams.append('IsNonveg', <any>isNonveg) as any || formParams;
        }
        if (dsSmallText !== undefined) {
            formParams = formParams.append('DsSmallText', <any>dsSmallText) as any || formParams;
        }
        if (dsMediumText !== undefined) {
            formParams = formParams.append('DsMediumText', <any>dsMediumText) as any || formParams;
        }
        if (dsLargeText !== undefined) {
            formParams = formParams.append('DsLargeText', <any>dsLargeText) as any || formParams;
        }
        if (dsImageCode !== undefined) {
            formParams = formParams.append('DsImageCode', <any>dsImageCode) as any || formParams;
        }
        if (isActive !== undefined) {
            formParams = formParams.append('IsActive', <any>isActive) as any || formParams;
        }
        if (itemImage !== undefined) {
            formParams = formParams.append('ItemImage', <any>itemImage) as any || formParams;
        }
        if (isBanner !== undefined) {
            formParams = formParams.append('IsBanner', <any>isBanner) as any || formParams;
        }

        return this.httpClient.request<ItemOutputDto>('put',`${this.basePath}/api/Item/Put`,
            {
                body: convertFormParamsToString ? formParams.toString() : formParams,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param cdItem 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiItemUpdateOptionalPost(body?: Array<number>, cdItem?: number, observe?: 'body', reportProgress?: boolean): Observable<ItemOutputDto>;
    public apiItemUpdateOptionalPost(body?: Array<number>, cdItem?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ItemOutputDto>>;
    public apiItemUpdateOptionalPost(body?: Array<number>, cdItem?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ItemOutputDto>>;
    public apiItemUpdateOptionalPost(body?: Array<number>, cdItem?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdItem !== undefined && cdItem !== null) {
            queryParameters = queryParameters.set('cdItem', <any>cdItem);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ItemOutputDto>('post',`${this.basePath}/api/Item/UpdateOptional`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
